import React, {useEffect} from "react";
import {CheckIcon} from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const Checkbox = ({
                             label,
                             onChange,
                             isDisabled = false,
                             isChecked,
                             ariaLabel,
                             dataCy,
                             inputId,
                             tabIndex,
                             onKeyDown
                         }: {
    label?: string,
    isDisabled?: boolean,
    isChecked?: boolean,
    ariaLabel?: string,
    dataCy?: string,
    inputId?: string,
    tabIndex?: number,
    onChange: ((event: React.MouseEvent<HTMLLabelElement>) => void),
    onKeyDown?: ((event: React.KeyboardEvent<HTMLInputElement>) => void)
}): React.ReactElement | null => {

    const inputRef = React.useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {

            const isCheckedClass = "checked";
            if (isChecked) {
                // @ts-ignore
                inputRef.current.classList.add(isCheckedClass);
            } else {
                // @ts-ignore
                inputRef.current.classList.remove(isCheckedClass);
            }
        }
    }, [isChecked]);

    const handleClick = (event: React.MouseEvent<HTMLLabelElement>) => {
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onChange(event);
    }

    return (
        <label className="ga-checkbox  w-100 d-inline-flex cursor-pointer" onClick={handleClick} role={"button"}>
            <input type="checkbox" className={`ga-checkbox__native  ${isChecked ? " checked" : ""}`}
                   ref={inputRef}
                   id={inputId}
                   onKeyDown={onKeyDown}
                   aria-label={ariaLabel}
                   data-cy={dataCy}
                   tabIndex={tabIndex}
                   checked={isChecked}
                   disabled={isDisabled}
            />

            <div className="ga-checkbox__marker">
                <CheckIcon className="ga-checkbox__marker__indicator-checked" size={ICON_SIZE.XSMALL} strokeWidth={2}
                           absoluteStrokeWidth={true}/>
            </div>

            {/* span, not a for-bound label: the outer label already forwards clicks, and a second association double-fires onChange */}
            <span className="ga-checkbox__label">{label}</span>
        </label>
    )
};

export default Checkbox;